import { FC } from 'react'
import router from 'next/router'
import { Text, Button } from '@/client/components'
import * as S from './styles'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ScubscriptionPanel: FC<any> = ({ newsletter }) => {
  const redirectTo = (pathName) => {
    router.push(pathName)
  }
  return (
    <>
      <S.ScubscriptionPanel>
        <Text as='p' size='lg' weight='bold' style={{ textAlign: 'center', width: '100%', margin: '0' }}>
          {newsletter['title']}
        </Text>
        <Text as='p' size='sm' color='weak' style={{ textAlign: 'center', width: '100%' }}>
          {newsletter['description']}
        </Text>
        <S.ButtonLinks>
          {newsletter['links'] &&
            newsletter['links'].map((e) => (
              <Button
                key={`key_${e['url']}`}
                kind='action'
                onClick={() => {
                  redirectTo(e['url'])
                }}
              >
                {e['label']}
              </Button>
            ))}
        </S.ButtonLinks>
      </S.ScubscriptionPanel>
    </>
  )
}
